import React from "react";
import { Input } from "semantic-ui-react";

/**
 * A search filter component for filtering tree nodes.
 * Shows a search input and displays the number of results.
 */
const TreeFilter = ({
  filterText,
  onFilterChange,
  resultsCount,
  placeholder = "Search columns..."
}) => {
  return (
    <div className="checkbox-tree-filter">
      <Input
        icon="search"
        placeholder={placeholder}
        value={filterText}
        onChange={(e) => onFilterChange(e.target.value)}
        fluid
      />
      {filterText && (
        <div className="filter-results-count">
          {resultsCount === 0
            ? "No matches found"
            : "Showing matching results"}
        </div>
      )}
    </div>
  );
};

export default TreeFilter;
